import { Appendix } from "../../../../shared/entities/scripts/appendix";
import { VisitLookup } from "../../../reporting/data-completeness/components/visits-tab/scripts/visits.lookup";
import { BiospecimenInventoryLookup } from "../../inventory-summary/scripts/inventory-lookup";

export class SampleSearchResult {
    StudyId: number;
    TimepointId: number;
    SampleTypeId: number;
    StatusId: number;
    UnitTypeId: number;
    SubjectId: number;
    SampleId: number;
    ParentSampleId: number;
    VisitNameId: number;

    Study: string;
    Timepoint: string;
    SampleType: string;
    Status: string;
    Unit: string;
    UnitType: string;
    Patient: string;
    Sample: string;
    VisitName: string;

    Volume: number;
    ThawCount: number;
    TargetDay: number;

    constructor() { }

    initialize(): void {
        this.Sample = this.ParentSampleId?.toString();
        this.Patient = this.SubjectId?.toString();
        this.Unit = this.SampleId?.toString();
        this.Study = BiospecimenInventoryLookup.GetValueFromIdAndType(this.StudyId, 'study');
        this.Status = BiospecimenInventoryLookup.GetValueFromIdAndType(this.StatusId, 'specimen-status');
        this.VisitName = VisitLookup.GetVisitMasterColumn(this.VisitNameId);
        this.Timepoint = BiospecimenInventoryLookup.GetValueFromIdAndType(this.TimepointId, 'timepoint');
        this.SampleType = BiospecimenInventoryLookup.GetValueFromIdAndType(this.SampleTypeId, 'sample-type');
        this.UnitType = BiospecimenInventoryLookup.GetValueFromIdAndType(this.UnitTypeId, 'unit');
    }
}

export class SortColumn {
    colIndex: number;
    propertyName: string;
    type: string;
    constructor(colIndex: number, propertyName: string, type: string) {
        this.colIndex = colIndex;
        this.propertyName = propertyName;
        this.type = type;
    }
}